//import { PolyLabel } from "./class/PolyLabel";
import { ITag, ITagGeofenceMapping } from "@app/interfaces/ITag";
import { IGroupWithIds } from "@app/main/components/resourceManagement/groups/_models/IGroupWithIds";
import { GeofenceOverlay } from "@directives/_map/geofences/geofenceoverlay";
import { IGeofenceNavigationPoint } from "@directives/_map/geofences/geofences.interfaces";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { ICoords } from "@interfaces/ICoords";
import { IDeleteVertexParams } from "@interfaces/IDeleteVertexParams";
import { GeofenceCategory, IGeofence } from "@interfaces/IGeofences";
import { IPlot } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import * as polylabel from "@mapbox/polylabel";
import { AccountService } from "@services/account.service";
import { ConstantsService } from "@services/constantsService";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import copy from "fast-copy";
import * as moment from "moment";
import { IGeoArea } from "src/app/main/modules/tms/_models/IGeoArea";
import { GeofenceType } from "../enum/GeofenceType";
import { CacheService } from "./cache.Service";
import { DisplayService, IDialogOptionsJson } from "./display.service";
import { DriverService } from "./driver.service";
import { GeocodeService, IViewPort } from "./geocode.service";
import { TagResourceType, TagsService } from "./tags.service";
import { VehicleService } from "./vehicle.service";

export interface IGetGeofenceOptions {
    includeTags?: boolean;

    invalidateCache?: boolean;
    unsafe?: boolean;
}

export interface IGeofenceShapeValidation {
    valid: boolean;
    failedReason?: string;
    geofence: IGeofence;
}

export interface IGeofenceColors {
    strokeColor: string;
    strokeOpacity: number;
    strokeWeight: number;
    fillColor: string;
    fillOpacity: number;
    zIndex: number;
}

export interface IAccumulatedData {
    AccelerationCountGps: number;

    OverAccelerationDuration: number;

    BrakeApplications: number;

    BrakeApplicationsOverThreshold: number;

    BrakeDistance: number;

    BadAnticipationCount: number;

    CoastingDuration: number;

    CoastingDistance: number;

    CruiseDuration: number;

    CorneringCountGps: number;

    DecelerationCountGps: number;

    DrivingDuration: number;

    EngineOnDuration: number;

    FuelUsedDriving: number;

    FuelUsedIdle: number;

    FuelUsedPto: number;

    FuelUsedTotal: number;

    PtoDuration: number;

    OverRevDuration: number;

    OverSpeedDuration: number;

    OverTorqueDuration: number;

    IdlingDuration: number;

    OverIdlingDuration: number;

    OverIdlingCount: number;
}

export interface IAggregatedData extends IAccumulatedData {
    AverageSpeed: number;

    Distance: number;

    DistanceKm: number;

    OdometerKmStart: number;

    OdometerKmEnd: number;

    MaxSpeedKph: number;

    DistanceKmCan: number;

    FuelLevelStart: number;

    FuelLevelEnd: number;

    OdometerKmCanStart: number;

    OdometerKmCanEnd: number;
}

export interface IGeofenceVisit {
    Id: number;
    GeofenceId: number;
    VehicleId: number;

    IgnitionStateCount: number;
    StartPlotId: number;
    EndPlotId: number;
    StartUtc: string;
    EndUtc: string;

    // ---

    geofence: IGeofence;
    vehicle?: IVehicle;
    duration?: number;
    durationFormatted?: string;
}

export interface IShowGeofenceEditorOptions {
    focusedLatLngs?: google.maps.LatLng;
    resource?: IVehicle | IPlot;
    onGeofenceEditorCancelled?: () => void;
    onGeofenceEditorSaved?: (geofence: IGeofence) => void;
    onGeofenceEditorDeleted?: (geofence: IGeofence) => void;
}

export interface ICachedById<ID, T> {
    id: ID,
    data: T
}

//app.components_resourceManagement({page:'geofences', model:$ctrl.popupModel.Id, modelType:'geofence',panel:'edit'})"
export class GeofenceService {

    blueGeofenceColors: IGeofenceColors = {
        strokeColor: "rgb(0, 66, 106)",
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: "rgb(0, 66, 106)",
        fillOpacity: 0.6,
        zIndex: 1
    }

    defaultGeofenceColors: IGeofenceColors = {
        strokeColor: "rgb(50, 50, 50)",
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: "rgb(50, 50, 50)",
        fillOpacity: 0.4,
        zIndex: 1
    }

    selectedGeofenceColors: IGeofenceColors = {
        strokeColor: "rgb(160, 16, 0)",
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: "rgb(160, 16, 0)",
        fillOpacity: 0.4,
        zIndex: 100
    }

    private readonly MAX_POLYGON_AREA = 3150000;
    private readonly MIN_POLYGON_AREA = 3925;

    private readonly MAX_GEOFENCE_RADIUS = 1000;
    private readonly MIN_GEOFENCE_RADIUS = 50;

    private accoundId: number;
    private geofenceCacheName = "geofences";
    private navPointCacheName = "navPoints";
    isDemoSite: boolean;

    static $inject = ["$q", "$http", "cacheService", "geocodeService", "vehicleService", "tagsService", "driverService", "displayService", "constantsService", "translationService", "accountService", "$sanitize"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $http: angular.IHttpService,
        private readonly cacheService: CacheService,
        private readonly geocodeService: GeocodeService,
        private readonly vehicleService: VehicleService,
        private readonly tagsService: TagsService,
        private readonly driverService: DriverService,
        private readonly displayService: DisplayService,
        private readonly constantsService: ConstantsService,
        private readonly translationService: TranslationService,
        private readonly accountService: AccountService,
        private readonly $sanitize
    ) {
        this.isDemoSite = this.constantsService.getIsDemoSite();

        this.cacheService.createCache(this.geofenceCacheName, {
            deleteOnExpire: "passive",
            maxAge: 60 * 60 * 1000, // 60min default
        });

        this.cacheService.createCache(this.navPointCacheName, {
            deleteOnExpire: "passive",
            maxAge: 60 * 60 * 1000, // 60min default
        });

    }

    //calculateConvexHull(polygon: google.maps.Polygon): google.maps.LatLng[] {
    //    var points: google.maps.LatLng[] = polygon.getPath().getArray()

    //    points.sort((a, b) => { return a.lng() - b.lng(); });
    //    points.sort((a, b) => { return a.lat() - b.lat(); });

    //    return points;
    //}

    getGeofenceNavigationPoints(geofenceId: number): angular.IPromise<IGeofenceNavigationPoint[]> {
        return this.cacheService.getOrRetrieveItem<ICachedById<number, IGeofenceNavigationPoint[]>, IGeofenceNavigationPoint[]>(
            this.navPointCacheName,
            () => this.getGeofenceNavigationPointsFromDatabase(geofenceId),
            (navigationPoints) => {
                return { id: geofenceId, data: navigationPoints };
            },
            (cache) => cache.data,
            geofenceId
        );
    }

    getGeofenceNavigationPointsFromDatabase(geofenceId: number): angular.IPromise<IGeofenceNavigationPoint[]> {
        return this.$http({
            url: `/api/navigationpoints/${geofenceId}`,
            method: "GET"
        })
            .then((result: angular.IHttpPromiseCallbackArg<IGeofenceNavigationPoint[]>) => {
                return result.data;
            });
    }

    saveGeofenceNavigationPoints(geofenceId: number, geofenceNavigationPoints: IGeofenceNavigationPoint[] = []): angular.IPromise<any> {
        return this.$http
            .post(`/api/navigationpoints/${geofenceId}`, geofenceNavigationPoints)
            .then((result: angular.IHttpPromiseCallbackArg<any>) => {
                this.cacheService.upsertItem<ICachedById<number, IGeofenceNavigationPoint[]>>(
                    this.navPointCacheName,
                    geofenceId,
                    { id: geofenceId, data: geofenceNavigationPoints },
                    (cache, newItem) => { cache.data = newItem.data }
                );
                return result.data;
            });
    }

    getGeofenceVisitsByGeofence(geofenceId: number, startDate: moment.Moment, endDate: moment.Moment): angular.IPromise<IGeofenceVisit[]> {
        const visitsPromise = this
            .$http({
                url: `/api/geofencevisits/geofence/${geofenceId}?start=${startDate.toISOString()}&end=${endDate.toISOString()}`,
                method: "GET"
            })
            .then((result: angular.IHttpPromiseCallbackArg<IGeofenceVisit[]>) => {
                return result.data;
            });

        return this.getAndMapVehiclesToVisits(visitsPromise);
    }

    getGeofenceVisitsByVehicle(vehicleId: number, startDate: moment.Moment, endDate: moment.Moment, includeAllIntersecting = true): angular.IPromise<IGeofenceVisit[]> {
        const visitsPromise = this
            .$http({
                url: `/api/geofencevisits/vehicle/${vehicleId}?start=${startDate.toISOString()}&end=${endDate.toISOString()}`,
                method: "GET",
                params: {
                    includeAllIntersecting: includeAllIntersecting
                }
            })
            .then((result: angular.IHttpPromiseCallbackArg<IGeofenceVisit[]>) => {
                //console.log("raw", result.data[0])

                // May not want to stay in here - any visits that start or end after the time window will be time limited to the window itself
                // CJE removed 16/10/2019
                //result.data.forEach(visit => {
                //    if (startDate.isAfter(visit.StartUtc)) {
                //        visit.StartUtc = startDate.toISOString();
                //    }

                //    if (endDate.isBefore(visit.EndUtc)) {
                //        visit.EndUtc = endDate.toISOString();
                //    }
                //});

                return result.data;
            });

        return this.getAndMapVehiclesToVisits(visitsPromise);
    }

    getGeofenceVisits(startDate: moment.Moment | Date, endDate: moment.Moment | Date, mapVehiclesAndDrivers = true): angular.IPromise<IGeofenceVisit[]> {
        const visitsPromise = this
            .$http({
                url: `/api/geofencevisits?start=${startDate.toISOString()}&end=${endDate.toISOString()}`,
                method: "GET"
            })
            .then((result: angular.IHttpPromiseCallbackArg<IGeofenceVisit[]>) => {
                return result.data;
            });

        if (mapVehiclesAndDrivers) {
            return this.getAndMapVehiclesToVisits(visitsPromise);
        }

        return visitsPromise;
    }

    getGeofences(options?: IGetGeofenceOptions): angular.IPromise<IGeofence[]> {
        const geofencesPromise = this.cacheService.getOrRetrieveData(this.geofenceCacheName, () => this.getGeofencesFromDatabase(), options?.invalidateCache, options?.unsafe);
        const tagMappingPromise = options?.includeTags ? this.tagsService.getTagGeofenceMappings({}, options?.invalidateCache) : this.$q.when<ITagGeofenceMapping[]>([]);
        const tagsPromise = options?.includeTags ? this.tagsService.getTags({ Active: true, invalidateCache: options?.invalidateCache }) : this.$q.when<ITag[]>([]);

        return this.$q
            .all([tagMappingPromise, tagsPromise, geofencesPromise])
            .then(([tagMappings, tags, geofences]) => {
                this.tagsService.mapTagMappingsToResources(tagMappings, geofences, TagResourceType.Geofence);

                if (tags?.length && geofences?.length) {

                    geofences.forEach(geofence => {
                        if (!geofence.TagIds?.length) {
                            return;
                        }

                        geofence.Tags = tags.filter(tag => geofence.TagIds.find(geofenceTagId => geofenceTagId === tag.Id));

                        if (!geofence.Tags?.length) {
                            return;
                        }

                        geofence.Tags.sort((t1, t2) => {
                            return t1.Position < t2.Position ? -1 : 1;
                        });

                        geofence.PriorityTag = geofence.Tags[0];
                    })
                }

                return geofences;
            });

    }

    getGeofenceById(geofenceId: number, options?: IGetGeofenceOptions, invalidateCache = false): angular.IPromise<IGeofence> {

        const geofencePromise = this
            .$http({
                url: `/api/geofences/${geofenceId}`,
                method: "GET",
                params: {
                    invalidateCache: invalidateCache
                }
            })
            .then((result: angular.IHttpPromiseCallbackArg<IGeofence>) => {
                return result.data;
            });

        const tagMappingPromise = options?.includeTags ? this.tagsService.getTagGeofenceMappings({}, invalidateCache) : this.$q.when<ITagGeofenceMapping[]>([]);

        return this.$q
            .all([tagMappingPromise, geofencePromise])
            .then(([tagMappings, geofence]) => {

                this.tagsService.mapTagMappingsToResources(tagMappings, [geofence], TagResourceType.Geofence);

                return geofence;
            });
    }

    createGeofenceOverlays(map: google.maps.Map, geofences: IGeofence[], showLabelWhenZoomedOut: boolean, drawImmediately = false) {
        window.performance.mark("createGeofenceOverlays");
        const overlays: GeofenceOverlay[] = [];

        if (!geofences) {
            return overlays;
        }

        let i = geofences.length;
        while (i--) {
            const geofence = geofences[i];
            const overlay = this.createGeofenceOverlay(geofence, map, showLabelWhenZoomedOut, drawImmediately);

            if (overlay) {
                overlays.push(overlay);
            }
        }

        // Sort by size
        //overlays.sort((overlay1, overlay2) => {
        //    return this.getGeofenceOverlayArea(overlay1) > this.getGeofenceOverlayArea(overlay2)
        //        ? 1
        //        : -1;
        //});
        window.performance.measure("createGeofenceOverlays");

        return overlays;
    }

    getGeofenceOverlayArea(geofenceOverlay: GeofenceOverlay) {
        var ne = geofenceOverlay.bounds.getNorthEast(); // LatLng of the north-east corner
        var sw = geofenceOverlay.bounds.getSouthWest(); // LatLng of the south-west corder
        var nw = new google.maps.LatLng(ne.lat(), sw.lng());
        var se = new google.maps.LatLng(sw.lat(), ne.lng());

        var latLngList: google.maps.LatLng[] = [ne, nw, sw, se];
        return google.maps.geometry.spherical.computeArea(latLngList);
    }

    createGeofenceCoords(geofence: IGeofence) {
        if (!geofence.MapCoords) {
            geofence.MapCoords = new google.maps.LatLng(geofence.Latitude, geofence.Longitude);
        }
    }

    setPolygonGeofenceVisualCenter(geofence: IGeoArea) {
        if (!geofence.Points?.length) {
            console.error("Tried to set visual center on geofence with no points", geofence);
            return;
        }

        const center = polylabel([geofence.Points], 0.00001);

        [geofence.Latitude, geofence.Longitude] = center;
    }

    createGeofenceOverlay(geofence: IGeofence, map: google.maps.Map, showLabelWhenZoomedOut: boolean, drawImmediately = false): GeofenceOverlay {

        if (!geofence) {
            return null;
        }

        if (geofence.GeofenceType == GeofenceType.Circle) {
        }
        else if (geofence.GeofenceType == GeofenceType.Polygon) {
            var coords = [];

            if (!geofence.Points) {
                //console.error("Geofence set to polygon but has no points", geofence);

                return null;
            }

            for (var i = 0; i < geofence.Points.length; i++) {
                const [lat, lng] = geofence.Points[i];
                coords.push({ lat, lng });
            }
        }
        else {
            return null;
        }

        this.createGeofenceCoords(geofence);

        return new GeofenceOverlay(geofence, map, showLabelWhenZoomedOut, drawImmediately);
    }

    createNewGeofence(latLngs: google.maps.LatLng, resource?: IVehicle | IPlot): angular.IPromise<IGeofence> {

        const newGeofence: IGeofence = {
            Id: 0,
            Radius: 150,
            Category: GeofenceCategory.Standard,
            Latitude: latLngs.lat(),
            Longitude: latLngs.lng(),
            GeofenceType: GeofenceType.Circle,
            Email: "",
            Description: "",
            Tags: [],
            TagIds: [],
            Addr3: ""
        };

        let addressPromise = this.$q.resolve(this.geocodeService.getAddressFromPoint(latLngs));

        if (!!resource && !("Reg" in resource)) {
            addressPromise = this.$q.resolve(this.geocodeService.getLocationInformationFromPlotId(resource.Id));
        }

        return this.$q
            .all([
                this.accountService.getAccountData(),
                addressPromise,
            ])
            .then(([account, geocodedAddress]) => {
                newGeofence.AccountId = account?.Id;
                newGeofence.Addr3 = geocodedAddress.LocationDescription;

                return this.$q.resolve(newGeofence);
            });
    }

    createGeofenceCoordsFromLatLng(latLng: google.maps.LatLng): ICoords {
        var coords: ICoords = {
            Latitude: latLng.lat(),
            Longitude: latLng.lng()
        };

        return coords;
    }

    saveGeofence(geofence: IGeofence): angular.IPromise<number> {
        var geofenceCopy = this.createSerializeableGeofenceCopy(geofence);
        const isSystemGeofence = (geofenceCopy.isSystemGeofence != null ? geofenceCopy.isSystemGeofence : false);

        return this.$http({
            url: `/api/geofences/`,
            method: "POST",
            data: geofenceCopy,
            params: { isSystemGeofence: isSystemGeofence }
        }).then((result: angular.IHttpPromiseCallbackArg<number>) => {

            if (!geofence.Id && result.data) {
                geofence.Id = result.data;
            }

            return this.tagsService.saveResourceTags(geofence, TagResourceType.Geofence).then(() => {
                geofence = this.removeAndResetGeofenceTags(geofence);

                this.updateOrInsertGeofenceCache(geofence);

                return geofence.Id;
            });
        });
    }

    updateOrInsertGeofenceCache(geofence: IGeofence): void {
        this.cacheService.addOrUpdateItem(this.geofenceCacheName, geofence, (v1, v2) => v1.Id == v2.Id);
    }

    importGeofences(geoFences: IGeofence[]): angular.IPromise<any> {
        const geofencesCopy = this.createSerializeableGeofencesCopy(geoFences);

        return this.$http
            .post("/api/geofences/import", geofencesCopy)
            .then((result: angular.IHttpPromiseCallbackArg<any>) => {
                return result.data;
            });
    }

    createSerializeableGeofenceCopy(geofenceSource: IGeofence): IGeofence {
        var geofenceCopy: IGeofence = {};

        for (var key in geofenceSource) {
            if (geofenceSource.hasOwnProperty(key) && key !== "MapObject") {
                geofenceCopy[key] = angular.copy(geofenceSource[key]);
            }
        }

        return geofenceCopy;
    }

    createSerializeableGeofencesCopy(geofencesSource: IGeofence[]): IGeofence[] {
        const geofencesCopy: IGeofence[] = [];

        geofencesSource.forEach((geofenceSource) => {
            geofencesCopy.push(this.createSerializeableGeofenceCopy(geofenceSource));
        });

        return geofencesCopy;
    }

    deleteGeofence(geofence: IGeofence): angular.IPromise<any> {
        geofence.PendingDelete = true;

        return this.$http
            .delete("/api/geofences/" + geofence.Id)
            .then(() => {
                this.cacheService.deleteItem(this.geofenceCacheName, geofence, (v1, v2) => v1.Id == v2.Id)
            });
    }

    destroyGeofence(geofence: google.maps.Circle | google.maps.Polygon) {
        if (geofence) {
            google.maps.event.clearInstanceListeners(geofence);
            geofence.setMap(null);
            geofence = null;
        }
    }

    setGeofenceAddressFromPosition(geofence: IGeofence): angular.IPromise<void> {
        return this.geocodeService
            .getAddressFromPoint(new google.maps.LatLng(geofence.Latitude, geofence.Longitude))
            .then(address => {

                if (!geofence || !address.LocationDescription) {
                    geofence.Addr1 = "";
                    geofence.Addr2 = "";
                    geofence.Addr3 = "";
                    geofence.Addr4 = "";

                    return;
                }

                // Split up formatted address by comma
                var addressComponents = address.LocationDescription.split(",");
                geofence.Addr1 = addressComponents[0];
                geofence.Addr2 = addressComponents[1];
                geofence.Addr3 = addressComponents[2];
                geofence.Addr4 = addressComponents[3];
            });
    }

    addDeleteVertexButtonToPolygon(deleteVertexParams: IDeleteVertexParams) {
        if (!deleteVertexParams || !deleteVertexParams.polygon || !deleteVertexParams.polygon.getPath()) {
            console.error("No polygon / path");
        }

        // This is a bit hacky
        const path = deleteVertexParams.polygon.getPath();
        path["btnDeleteClickHandler"] = {};
        path["btnDeleteImageUrl"] = "/assets/images/polyline_delete_button.png";

        //google.maps.event.addListener(polygon, "click", (event: google.maps.PolyMouseEvent) => { this.callback(path, event.vertex); });
        google.maps.event.addListener(path, "set_at", (index: number) => { this.callback(path, index, deleteVertexParams); });
        google.maps.event.addListener(path, "insert_at", (index: number) => { this.callback(path, index, deleteVertexParams); });
    }

    removeDeleteVertexButtonFromPolygon() {

        var deleteButton = angular.element("#googleMapsDeletePolyVertexButton");
        if (deleteButton.length > 0) {
            deleteButton.remove();
        }
    }

    pointIsInsideGeofence(point: google.maps.LatLng, geoArea: IGeoArea): boolean {
        const x = point.lat();
        const y = point.lng();

        if (geoArea.GeofenceType == GeofenceType.Circle) {
            return google.maps.geometry.spherical.computeDistanceBetween(point, geoArea.MapCoords) <= geoArea.Radius;
        }

        // ray-casting algorithm based on
        // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html

        const vs = geoArea.Points;

        let inside = false;
        for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            const xi = vs[i][0];
            const yi = vs[i][1];
            const xj = vs[j][0];
            const yj = vs[j][1];

            const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);

            if (intersect) {
                inside = !inside;
            }
        }

        return inside;
    }

    findGeofence(geofences: IGeofence[], geofenceId: number): IGeofence {
        for (let i = 0; i < geofences.length; i++) {
            const geofence = geofences[i];

            if (geofence.Id == geofenceId) {
                return geofence;
            }
        }

        return null;
    }

    searchGeofences(geofences: IGeofence[], searchString: string): IGeofence[] {
        return geofences.filter(g => g.Description.localeCompare(searchString, undefined, { 'sensitivity': 'base' }))
    }

    fitMapToGeofences(veriMap: IVeriMapComponent, geofence: IGeofence, geofences: IGeofence[], bounds: IViewPort = null) {
        if (!veriMap) {
            return;
        }

        var latLngList: google.maps.LatLng[] = [];

        if (geofence) {
            const points: [number, number][] = this.getAllGeofencePoints(geofence);

            if (points?.length > 0) {
                points.forEach(point => {
                    latLngList.push(new google.maps.LatLng(point[0], point[1]));
                });
            }
            else {
                var geofenceCenter = new google.maps.LatLng(geofence.Latitude, geofence.Longitude);
                var gTop = google.maps.geometry.spherical.computeOffset(geofenceCenter, geofence.Radius, 0);
                var gBottom = google.maps.geometry.spherical.computeOffset(geofenceCenter, geofence.Radius, 180);
                latLngList.push(gTop);
                latLngList.push(gBottom);
            }
        }
        else if (!geofence && geofences && geofences.length > 0) {
            geofences.forEach(geofence => {
                latLngList.push(new google.maps.LatLng(geofence.Latitude, geofence.Longitude));
            });
        }
        else {
            if (bounds) {
                latLngList.push(new google.maps.LatLng(bounds.northeast.lat, bounds.northeast.lng));
                latLngList.push(new google.maps.LatLng(bounds.southwest.lat, bounds.southwest.lng));
            }
            else {
                latLngList.push(new google.maps.LatLng(55.811741, 1.76896));
                latLngList.push(new google.maps.LatLng(49.871159, -6.37988));
            }

        }

        veriMap.fitMap(latLngList);
    }

    findGeofenceVisitsToDepotsOrHomeLocations(geofenceVisits: IGeofenceVisit[], depotsWithHomeLocations: IGroupWithIds[]): IGeofenceVisit[] {
        return geofenceVisits.filter(geofenceVisit => {

            if (!geofenceVisit.vehicle) {
                return false;
            }

            // If we have a vehicle home location, and this isnt it, then we are not inside our home location
            if (geofenceVisit.vehicle.GeofenceId && geofenceVisit.vehicle.GeofenceId == geofenceVisit.GeofenceId) {
                return true;
            }

            // Find my depot
            var vehicleDepot = depotsWithHomeLocations.find(g => g.VehicleIds.indexOf(geofenceVisit.VehicleId) >= 0);

            if (vehicleDepot && vehicleDepot.GeofenceId == geofenceVisit.GeofenceId) {
                return true;
            }

            return false;
        });
    }

    showGeofenceEditor(
        geofence: IGeofence = null,
        $event: MouseEvent,
        options?: IShowGeofenceEditorOptions) {

        const dialogTitle = (geofence) ? this.translationService.t('geofenceService.geofenceName', geofence?.Description) : this.translationService.t('geofenceService.createNewGeofence');
        const dialogTitleSanitized = this.$sanitize(dialogTitle);

        const dialogOptions: IDialogOptionsJson = {
            title: dialogTitleSanitized,
            dialogHTML: `<geofence-editor ` +
                `class="dialog-mode" ` +
                `geofence="$ctrl.geofence"` +
                `resource="$ctrl.resource"` +
                `focused-lat-lngs="$ctrl.focusedLatLngs"` +
                `on-geofence-editor-cancelled="$ctrl.onGeofenceEditorCancelled(); $ctrl.hide();" ` +
                `on-geofence-editor-saved="$ctrl.onGeofenceEditorSaved(geofence); $ctrl.hide();" ` +
                `on-geofence-editor-deleted="$ctrl.onGeofenceEditorDeleted(geofence); $ctrl.hide();"></geofence-editor>`,
            dialogId: `geofenceEditorComponent`,
            customClass: `geofence-editor-dialog`,
            multiple: true,
            bindings: {
                geofence: geofence,
                resource: options?.resource,
                focusedLatLngs: options?.focusedLatLngs,
                onGeofenceEditorCancelled: () => { options?.onGeofenceEditorCancelled() },
                onGeofenceEditorSaved: (savedGeofence: IGeofence) => { options?.onGeofenceEditorSaved(savedGeofence); },
                onGeofenceEditorDeleted: (deletedGeofence: IGeofence) => { options?.onGeofenceEditorDeleted(deletedGeofence); }
            },
            event: $event,
            preventFocusOnOpen: true
        };

        this.displayService.showDialog(dialogOptions);
    }

    validateGeofenceShape(geofence: IGeofence, ignoreMaxSize: boolean = false): IGeofenceShapeValidation {

        let newValidation: IGeofenceShapeValidation = {
            valid: false,
            geofence
        };

        if (!geofence) {
            newValidation.failedReason = this.translationService.t('geofenceService.noGeofenceProvided');

            return newValidation;
        }

        if (geofence.GeofenceType === GeofenceType.Circle) {
            const currentRadius = geofence.Radius;

            if (!ignoreMaxSize && currentRadius > this.MAX_GEOFENCE_RADIUS) {
                newValidation.failedReason = this.translationService.t('geofenceService.radiusMoreThan', this.MAX_GEOFENCE_RADIUS.toFixed(0));
                return newValidation;

            } else if (currentRadius < this.MIN_GEOFENCE_RADIUS) {
                newValidation.failedReason = this.translationService.t('geofenceService.radiusLessThan', this.MIN_GEOFENCE_RADIUS.toFixed(0));
                return newValidation;
            }

        } else if (geofence.GeofenceType === GeofenceType.Polygon) {

            const polyPath: google.maps.LatLng[] = [];

            geofence?.Points?.forEach(point => {
                polyPath.push(new google.maps.LatLng(point[0], point[1]));
            });

            if (polyPath.length === 0) {
                newValidation.failedReason = this.translationService.t('geofenceService.polygonNoPoints');
                return newValidation;
            }

            const currentPolyArea = google.maps.geometry.spherical.computeArea(polyPath);
            const maxAreaLabel = +(currentPolyArea - this.MAX_POLYGON_AREA).toFixed(0);
            const minAreaLabel = +(this.MIN_POLYGON_AREA - currentPolyArea).toFixed(0);

            if (!currentPolyArea) {
                newValidation.failedReason = this.translationService.t('geofenceService.polygonNoArea');
                return newValidation;
            }

            if (!ignoreMaxSize && currentPolyArea > this.MAX_POLYGON_AREA) {
                newValidation.failedReason = this.translationService.t('geofenceService.areaMoreThan', maxAreaLabel);
                return newValidation;

            } else if (currentPolyArea < this.MIN_POLYGON_AREA) {
                newValidation.failedReason = this.translationService.t('geofenceService.areaLessThan', minAreaLabel);
                return newValidation;
            }
        }

        newValidation.valid = !newValidation.failedReason;

        return newValidation;
    }

    getAllGeofencePoints(geofence: IGeofence): [number, number][] {
        if (!geofence?.Points?.length && !geofence?.Shapes?.length) {
            return null;
        }

        if (geofence?.Points?.length > 0) {
            return geofence?.Points;
        }

        let pointsArray: [number, number][] = [];

        geofence?.Shapes?.forEach(shape => {
            shape?.forEach(shapePoints => {
                pointsArray = [...pointsArray, shapePoints];
            });
        });

        return pointsArray;
    }

    createPolygonGroupForGeofence(geofence: IGeofence): google.maps.Polygon[] {
        let pointGroups: [number, number][][] = [geofence?.Points];

        if (geofence?.Shapes?.length > 0) {
            pointGroups = [...pointGroups, ...geofence?.Shapes]
        }

        if (pointGroups?.length === 0) { return null; }

        const newPolyGroups: google.maps.Polygon[] = [];

        pointGroups?.forEach(pointGroup => {
            const coords: google.maps.LatLng[] = this.getLatLngArrayFromPointsArray(pointGroup);
            if (coords?.length > 0) {
                newPolyGroups.push(new google.maps.Polygon({
                    paths: coords
                }));
            }
        });

        return newPolyGroups;
    }

    createPolygonsFromGeofences(geofences: IGeofence[] = []): google.maps.Polygon[] {
        let polygonGroups: google.maps.Polygon[] = [];

        geofences?.forEach(zone => {
            const polygonGroup: google.maps.Polygon[] = this.createPolygonGroupForGeofence(zone);
            if (polygonGroup) {
                polygonGroups = [...polygonGroups, ...polygonGroup]
            }
        });

        return polygonGroups;
    }

    getPolygonCenterCoordinates(geoJsonObject: any): google.maps.LatLngLiteral {

        const points = this.getPolygonPoints(geoJsonObject);

        if (!points.length) {
            console.log("Unsupported geoJSON type! Import works only with polygon and multipolygon. One shape at a time.");
            return;
        }

        const getMin = (coords, idx) => Math.min(...coords.map(c => c[idx]));
        const getMax = (coords, idx) => Math.max.apply(null, coords.map(c => c[idx]));
        const getCenter = (min, max) => min + (max - min) / 2;

        const minLat = getMin(points, 0);
        const maxLat = getMax(points, 0);
        const lat = getCenter(maxLat, minLat);

        const minLng = getMin(points, 1);
        const maxLng = getMax(points, 1);
        const lng = getCenter(maxLng, minLng);

        return { lat, lng };
    }

    getPolygonPoints(geoJsonObject: any): [number, number][] {

        let coords: [number, number][];

        switch (true) {
            case geoJsonObject?.features[0]?.geometry?.type == "MultiPolygon":
                coords = geoJsonObject?.features[0]?.geometry?.coordinates[0][0];
                break;

            case geoJsonObject?.features[0]?.geometry?.type == "Polygon":
                coords = geoJsonObject?.features[0]?.geometry?.coordinates[0];
                break;

            default:
                return [];
        }

        return coords.map(c => [c[1], c[0]]);
    }

    // ---

    private getGeofencesFromDatabase(): angular.IPromise<IGeofence[]> {

        return this.$http({ url: "/api/geofences", method: "GET", })
            .then((result: angular.IHttpPromiseCallbackArg<IGeofence[]>) => {

                if (this.isDemoSite) {
                    result.data.forEach((g, i) => {
                        g.Description = `Geofence ${i + 1}`;
                        g.DescriptionExt = `Geofence Description ${i + 1}`;
                    });
                }

                const geofences = result.data;

                for (var i = 0; i < geofences.length; i++) {
                    const geofence = geofences[i];

                    if (geofence.GeofenceType == GeofenceType.Polygon) {
                        // Some geofences are set as polygons but are in fact circles
                        if (geofence.Points?.length) {
                            // Set to 0.00001 to actually make this work, otherwise returns centre point
                            const center = polylabel([geofence.Points], 0.00001/*, isDebug*/);

                            geofence.Latitude = center[0];
                            geofence.Longitude = center[1];
                        }
                        else if (geofence.Radius != 0) {
                            geofence.GeofenceType = GeofenceType.Circle;
                        }
                    }

                    geofence.Tags = [];
                }

                return geofences;
            });
    }

    private getAndMapVehiclesToVisits(visitsPromise: angular.IPromise<IGeofenceVisit[]>): angular.IPromise<IGeofenceVisit[]> {
        const vehiclesPromise = this.vehicleService.getVehicles({ includePeripheralMappings: true });
        const driversPromise = this.driverService.getDrivers();

        return this.$q
            .all([visitsPromise, vehiclesPromise, driversPromise])
            .then(([visits, vehicles, drivers]) => {
                visits.forEach(visit => {
                    visit.vehicle = this.vehicleService.findVehicle(vehicles, visit.VehicleId);
                });

                return visits;
            });
    }

    private callback(path: google.maps.MVCArray<any>, index: number, deleteVertexParams: IDeleteVertexParams) {

        var btnDelete = angular.element(`img[src$='${path["btnDeleteImageUrl"]}']`);

        var polygonPoints = deleteVertexParams.polygon.getPath().getLength();
        var allowDelete = polygonPoints > 3;

        if (btnDelete.length === 0) {
            var undoimg = angular.element("img[src$='//maps.gstatic.com/mapfiles/undo_poly.png']");

            //undoimg.parent().css("height", "21px !important");
            undoimg
                .parent()
                .parent()
                .append(
                    `<div id="googleMapsDeletePolyVertexButton" style="overflow-x: hidden; overflow-y: hidden; position: absolute; width: 30px; height: 27px;top:21px;"><img src="${path["btnDeleteImageUrl"]
                    }" class="deletePoly" style="height:auto; width:auto; position: absolute; left:0;"/></div>`);

            // now get that button back again!
            btnDelete = angular.element(`img[src$='${path["btnDeleteImageUrl"]}']`);
            btnDelete.hover(
                function () {
                    $(this).css("left", "-30px");
                    return false;
                },
                function () {
                    $(this).css("left", "0px");
                    return false;
                });

            btnDelete.mousedown(function () {
                $(this).css("left", "-60px");
                return false;
            });
        }

        if (allowDelete)
            btnDelete.show();
        else
            btnDelete.hide();

        // if we've already attached a handler, remove it
        if (path["btnDeleteClickHandler"]) {
            btnDelete.unbind("click", path["btnDeleteClickHandler"]);
        }

        // now add a handler for removing the passed in index
        path["btnDeleteClickHandler"] = (params: any) => {

            path.removeAt(index);

            if (!params || !params.data || !params.data.geofence || !params.data.geofence.Points)
                return false;

            // update points collection on supplied geofence
            params.data.geofence.Points = [];
            const points = params.data.geofence.Points;

            path.forEach(p => {
                points.push([p.lat(), p.lng()]);
            });

            return false;
        };

        if (allowDelete) {
            btnDelete.one("click", { geofence: deleteVertexParams.geofence }, path["btnDeleteClickHandler"]);
        }
    }

    private getLatLngArrayFromPointsArray(points: [number, number][]): google.maps.LatLng[] {
        const latLngs: google.maps.LatLng[] = [];

        points?.forEach(point => {
            latLngs.push(new google.maps.LatLng(point[0], point[1]));
        });

        return latLngs;
    }

    private removeAndResetGeofenceTags(geofence: IGeofence): IGeofence {
        const amendedGeofence = copy(geofence);
        amendedGeofence.Tags = amendedGeofence.Tags?.filter(tag => geofence.TagIds.includes(tag.Id));
        amendedGeofence.PriorityTag = geofence.Tags[0] || null;
        return amendedGeofence;
    }
}
